/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import DatePicker from '../../../components/datePicker';
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Container from 'react-bootstrap/esm/Container';
import { getLocationDetails } from '../../../redux/slices/location/locationDetails';
import { useDispatch, useSelector } from 'react-redux';
import { AnyAction } from 'redux';
import { useLocales } from '../../../locales';
import IsLoadingIndicator from '../../../components/isLoadingIndicator';
import { newConfigsMap } from './config';
import { DEFAULT_RANGE } from '../../../components/datePicker/utils';
import { GOOGLE } from '../../../config/constants';
import {
  getAnalyticsForLocation,
  transferData
} from '../../../redux/slices/analytics/plotsData';
import { getUserDetails } from '../../../redux/slices/user/userDetails';
import { data } from './demoDataDocument';
import NewPlotTabs from '../../../components/plotTabs/newPlotTabs';
import { getAllDates } from '../../../utils/dateUtils';
import { ANALYICS_FOR_SOCIAL_MEDIA } from '../../../config/firebase/collections';
import { LomavisH2 } from '@/lomavisSharedUi/atoms/typography/LomavisH2';
import { getGrowthMetricsEntries } from '@/utils/analytics/growthMetricsUtils';
import { LomavisGrowthCardSectionTemplate } from '@/lomavisSharedUi/templates/cards/LomavisGrowthCardSectionTemplate';
import { googleFollowersGrowthConfig, googlePlatformActionsConfig, googlePlatformImpressionsConfig } from './growthConfig';

const GooglenalyticsPage: React.FC = () => {
  const { isLoading, uuid, demo, platforms_information } = useSelector(
    (state: any) => state.locationDetails
  );
  const { translate: t } = useLocales();
  const dispatch = useDispatch();
  const [error, setError] = useState(false);
  const { locationslug } = useParams();
  useEffect(() => {
    dispatch(getUserDetails() as unknown as AnyAction);
  }, [dispatch]);

  useEffect(() => {
    if (locationslug ?? '') {
      dispatch(getLocationDetails(locationslug) as unknown as AnyAction);
    }
  }, [dispatch, locationslug]);
  const [dates, setDates] = useState({
    ...DEFAULT_RANGE
  });
  const type = 'social_media_profile';
  const [plotsData, setPlotsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [oldPlotsData, setOldPlotsData] = useState(null);
  const [loadingOld, setLoadingOld] = useState(true);

  useEffect(() => {
    // ── 1. Demo mode ───────────────────────────────────────────────────────
    if (demo) {
      setPlotsData(data);
      setLoading(false);
      setLoadingOld(false);
      return;
    }

    // ── 2. Guard clauses ───────────────────────────────────────────────────
    if (!dates) return;
    // if(demo) {setPlotsData(transferData(demo, newConfigsMap)); return;}
    if (
      !isLoading &&
      uuid &&
      Object.keys(platforms_information).includes(GOOGLE)
    ) {
      setLoading(true);
      getAnalyticsForLocation(
        ANALYICS_FOR_SOCIAL_MEDIA,
        type,
        platforms_information[GOOGLE]?.[0]?.uuid,
        dates,
        GOOGLE
      )
        .then((res) => {
          setPlotsData(transferData(res, newConfigsMap));
          setLoading(false);
        })
        .catch((err) => {
          setError(true);
          console.log(err);
          setLoading(false);
        });
    }
  }, [uuid, isLoading, dates]);
  if (isLoading) return <IsLoadingIndicator />;
  return (
    <Container>
      <div className={'d-flex justify-content-center w-100 mb-10'}>
        <div className={'w-75 text-center rounded bg-white p-5 bg-white'}>
          {t('platform_analytics.google_info')}
        </div>
      </div>
      <div className="d-flex flex-column flex-lg-row justify-content-lg-end">
        <DatePicker setDates={setDates} />
      </div>
      <div className="m-2" />
      <LomavisH2 title={t('platform_analytics.title.KPISection')} />
                    {plotsData?.plots &&
                      Object.keys(plotsData?.plots).length > 0 &&
                      !loading && (
                        <>
                          <div className={'mb-5'} />
      
                          <div className="mb-10">
                            {plotsData?.plots && (
                              <LomavisGrowthCardSectionTemplate
                                title={t('platform_analytics.growth')}
                                entries={getGrowthMetricsEntries(
                                  plotsData?.plots || {},
                                  oldPlotsData?.plots || {},
                                  googleFollowersGrowthConfig,
                                  t,
                                  true
                                )}
                              />
                            )}
                          </div>
      
                          <div className="mb-10">
                            {plotsData?.plots && (
                              <LomavisGrowthCardSectionTemplate
                                title={t('platform_analytics.actions')}
                                entries={getGrowthMetricsEntries(
                                  plotsData?.plots || {},
                                  oldPlotsData?.plots || {},
                                  googlePlatformActionsConfig,
                                  t,
                                  true
                                )}
                              />
                            )}
                          </div>
      
                          <div className={'mb-10'}>
                            {plotsData?.plots && (
                              <LomavisGrowthCardSectionTemplate
                                title={t('platform_analytics.impressions')}
                                entries={getGrowthMetricsEntries(
                                  plotsData?.plots || {},
                                  oldPlotsData?.plots || {},
                                  googlePlatformImpressionsConfig,
                                  t,
                                  true
                                )}
                              />
                            )}
                          </div>
      
            
                          <div className={'mb-5'} />
                        </>
                      )}
                    {!plotsData?.plots && !loading && !error && (
                      <div
                        className="d-flex justify-content-center align-items-center m-4"
                        style={{ height: '200px' }}
                      >
                        <p className="text-muted">
                          {t('platform_analytics.no_data_available')}
                        </p>
                      </div>
                    )}
                    {error && (
                      <div
                        className="d-flex justify-content-center align-items-center m-4"
                        style={{ height: '200px' }}
                      >
                        <LomavisH2
                          title={t('platform_analytics.error_loading_data')}
                        />
                      </div>
                    )}
                    {loading && (
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ height: '200px' }}
                      >
                        <IsLoadingIndicator />
                      </div>
                      )}

                      <div className="mb-5" />
      <div className="m-2" />
      <NewPlotTabs
        hasError={error}
        labelsLength={getAllDates(dates.startDate, dates.endDate).length}
        data={plotsData}
        config={newConfigsMap}
        display={true}
        isLoading={loading}
      />
    </Container>
  );
};

export default GooglenalyticsPage;
